import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CartDetailsComponent } from '@spartacus/cart/base/components';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { isEmpty } from '@spartacus/cart/base/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rrs-cart-container',
  styleUrls: ['./rrs-cart-container.component.scss'],
  templateUrl: './rrs-cart-container.component.html',
})
export class RrsCartContainerComponent extends CartDetailsComponent {
  mergeInProgress$ = combineLatest([
    this.activeCartService.getActive(),
    this.activeCartService.isStable(),
    this.activeCartService.getLoading(),
  ]).pipe(
    distinctUntilChanged(),
    map(([cart, isCartStable, isLoading]) => {
      return isEmpty(cart) || !isCartStable || isLoading;
    })
  );
}
